"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentHeight = exports.getStyles = exports.DESCRIPTION_CONFIG = exports.TITLE_CONFIG = exports.PUBLISHER_CONFIG = exports.CONTENT_CONFIG = exports.THUMBNAIL_WIDTH_BREAKPOINTS = void 0;
var tslib_1 = require("tslib");
var lodash_1 = tslib_1.__importDefault(require("lodash"));
var parse_css_font_1 = tslib_1.__importDefault(require("parse-css-font"));
exports.THUMBNAIL_WIDTH_BREAKPOINTS = [
    275,
    399,
    400,
    500,
    700,
];
exports.CONTENT_CONFIG = {
    defaults: {
        marginTop: '6px',
        marginLeft: '15px',
        marginRight: '15px',
        paddingTop: '15px',
    },
    breakpoints: {
        400: {
            marginLeft: '20px',
            marginRight: '20px',
            paddingTop: '14px',
        },
        500: {
            paddingTop: '20px',
        },
    },
};
exports.PUBLISHER_CONFIG = {
    defaults: {
        marginBottom: '11px',
        fontSize: '12px',
        lineHeight: 1.17,
    },
    breakpoints: {
        400: {
            marginBottom: '13.5px',
            fontSize: '14px',
        },
        700: {
            fontSize: '16px',
        },
    },
};
exports.TITLE_CONFIG = {
    defaults: {
        fontSize: '14px',
        lineHeight: 1.43,
        marginBottom: '8px',
    },
    breakpoints: {
        400: {
            marginBottom: '11.5px',
            fontSize: '18px',
            lineHeight: 1.5,
        },
        700: {
            fontSize: '20px',
            lineHeight: 1.45,
        },
    },
};
exports.DESCRIPTION_CONFIG = {
    defaults: {
        fontSize: '12px',
        lineHeight: 1.67,
    },
    breakpoints: {
        400: {
            fontSize: '14px',
            lineHeight: 1.7,
        },
        700: {
            fontSize: '16px',
            lineHeight: 1.69,
        },
    },
};
var getStylesForWidth = function (stylesConfig) { return function (width) {
    var styles = stylesConfig.defaults;
    (0, lodash_1.default)(exports.THUMBNAIL_WIDTH_BREAKPOINTS)
        .takeWhile(function (breakpoint) { return breakpoint <= width; })
        .forEach(function (breakpoint) {
        var st = stylesConfig.breakpoints[breakpoint];
        if (st) {
            styles = tslib_1.__assign(tslib_1.__assign({}, styles), st);
        }
    });
    return styles;
}; };
var getContentStyles = getStylesForWidth(exports.CONTENT_CONFIG);
var getPublisherStyles = getStylesForWidth(exports.PUBLISHER_CONFIG);
var toNumber = function (value) {
    return typeof value === 'number' ? value : parseFloat(value);
};
var getFontStyle = function (size, lineHeight) {
    var sizeNumber = toNumber(size);
    if (typeof lineHeight === 'number') {
        lineHeight = "".concat(lineHeight * sizeNumber, "px");
    }
    return {
        lineHeight: lineHeight,
        fontSize: size,
        maxHeight: "".concat(parseFloat(lineHeight) * 2, "px"),
    };
};
var getTitleStyles = function (_a) {
    var width = _a.width, isOptimalFontSizes = _a.isOptimalFontSizes, titleFont = _a.titleFont;
    var title = getStylesForWidth(exports.TITLE_CONFIG)(width);
    var fontStyles;
    if (isOptimalFontSizes) {
        fontStyles = getFontStyle(title.fontSize, title.lineHeight);
    }
    else {
        var parsedFont = (0, parse_css_font_1.default)(titleFont.value);
        fontStyles = getFontStyle(titleFont.size, parsedFont.lineHeight);
    }
    return tslib_1.__assign(tslib_1.__assign({}, title), fontStyles);
};
var getDescriptionStyles = function (_a) {
    var width = _a.width, textFont = _a.textFont, isOptimalFontSizes = _a.isOptimalFontSizes;
    var description = getStylesForWidth(exports.DESCRIPTION_CONFIG)(width);
    return tslib_1.__assign(tslib_1.__assign({}, description), (isOptimalFontSizes
        ? getFontStyle(description.fontSize, description.lineHeight)
        : getFontStyle(textFont.size, description.lineHeight)));
};
var getStyles = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 275 : _b, _c = _a.isOptimalFontSizes, isOptimalFontSizes = _c === void 0 ? false : _c, titleFont = _a.titleFont, textFont = _a.textFont;
    return {
        content: getContentStyles(width),
        publisher: getPublisherStyles(width),
        title: getTitleStyles({ width: width, isOptimalFontSizes: isOptimalFontSizes, titleFont: titleFont }),
        description: getDescriptionStyles({ width: width, isOptimalFontSizes: isOptimalFontSizes, textFont: textFont }),
    };
};
exports.getStyles = getStyles;
var getHeight = function (styles) {
    var _a = styles.marginTop, marginTop = _a === void 0 ? 0 : _a, _b = styles.marginBottom, marginBottom = _b === void 0 ? 0 : _b, _c = styles.paddingTop, paddingTop = _c === void 0 ? 0 : _c, maxHeight = styles.maxHeight, fontSize = styles.fontSize, lineHeight = styles.lineHeight;
    var contentHeight = 0;
    if (maxHeight) {
        contentHeight = parseFloat(maxHeight);
    }
    else if (fontSize && lineHeight) {
        contentHeight = toNumber(fontSize) * toNumber(lineHeight);
    }
    return (contentHeight +
        toNumber(marginTop) +
        toNumber(marginBottom) +
        toNumber(paddingTop));
};
var getContentHeight = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 275 : _b, _c = _a.isOptimalFontSizes, isOptimalFontSizes = _c === void 0 ? false : _c, titleFont = _a.titleFont, textFont = _a.textFont, withPublisher = _a.withPublisher, withTitle = _a.withTitle, withDescription = _a.withDescription;
    var _d = (0, exports.getStyles)({
        width: width,
        isOptimalFontSizes: isOptimalFontSizes,
        textFont: textFont,
        titleFont: titleFont,
    }), content = _d.content, publisher = _d.publisher, title = _d.title, description = _d.description;
    return (getHeight(content) +
        (withPublisher ? getHeight(publisher) : 0) +
        (withTitle ? getHeight(title) : 0) +
        (withDescription ? getHeight(description) : 0));
};
exports.getContentHeight = getContentHeight;
//# sourceMappingURL=content.config.js.map